import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import { GenerateXlsxCasesResumeService } from 'src/app/modules/cases-archived/services/generate-xlsx-cases-resume.service';
import { ExportToCsv } from 'export-to-csv';
@Component({
  selector: 'auditory-app',
  templateUrl: './auditory.component.html',
  styleUrls: ['./auditory.component.scss'],
})
export class AuditoryComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private readonly router: Router,
    private userService: UserService,
    private caseService: CasesService,
    private readonly generateXlsxCasesResumeService: GenerateXlsxCasesResumeService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
  }

  unitId;
  form1 = false;
  currentUser = this.userService.currentUser;
  form2 = false;
  unit: boolean;
  searchTouch: boolean;
  ngOnInit() {
    this.getAuditory();
    this.caseService.filterRecord.subscribe({
      next: (filters: any) => {
        for (let key in filters) {
          if (
            filters[key] == '' ||
            filters[key] == 'null' ||
            filters[key] == null
          ) {
            delete filters[`${key}`];
          }
        }
        if (Object.keys(filters).length === 0) {
          this.getAuditory();
        } else {
          this.getRecordsFilters(filters);
        }
      },
    });
  }
  isLoading = true;
  async getRecordsFilters(filters) {
    this.isLoading = true;
    await this.caseService
      .getAllRecordFilters(filters)
      .subscribe(async (records) => {
        this.setDataAuditory(records);
      });
  }

  getAuditory() {
    this.isLoading = true;
    this.caseService
      .getAuditory()
      .subscribe((auditoryLogs) =>
        this.setDataAuditory(auditoryLogs.reverse())
      );
  }

  setData(cases: ICase[]) {
    this.list = cases;
    this.dataSource = new MatTableDataSource(cases);
    this.dataSource.paginator = this.paginator;
  }

  auditoryLogs: any[] = [];
  dataSourceAuditory;
  setDataAuditory(auditoryLogs: any[]) {
    auditoryLogs = this.transformAuditoryLogs(auditoryLogs);
    this.auditoryLogs = auditoryLogs;
    this.list = auditoryLogs;
    this.dataSourceAuditory = new MatTableDataSource<any>(auditoryLogs);
    this.dataSourceAuditory.paginator = this.paginator;
    this.isLoading = false;
  }

  public transformAuditoryLogs(auditoryLogs) {
    return auditoryLogs.map((log) => {
      const { action, user, more_info } = log;

      return {
        ...log,
        action: this.getActionText(action),
        id_user: user.username,
        role: user.role ? user.role.name : 'sin rol',
        more_info: more_info
          ? this.getMoreInfoText(action, more_info)
          : 'Sin más información',
      };
    });
  }
  count = 0;
  setCount(count) {
    this.count = count;
  }
  public back() {
    window.history.go(-1);
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('auditoryPaginator') paginatorAuditory: MatPaginator;

  dataSource: MatTableDataSource<ICase>;

  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSourceAuditory.paginator = this.paginatorAuditory;
    }, 1000);
  }

  list: ICase[] = [];

  displayedColumns: string[] = [
    'gai',
    'description',
    'caseType',
    'creator',
    'assigned',
    'created',
    'finished',
    'options',
  ];

  displayedColumnsAuditory: string[] = [
    'role',
    'id_user',
    'action',
    'ip',
    'date',
    'moreInfo',
  ];

  see(id) {
    this.router.navigate([`/case/${id}`]);
  }

  downloadResume() {
    this.generateXlsxCasesResumeService.generate();
  }

  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceAuditory.filter = filterValue.trim().toLowerCase();
  }

  private getMoreInfoText(action: string, more_info: any): string {
    switch (action) {
      case 'Login':
        return `Usuario: ${more_info}, ingreso al sistema`;

      case 'LogOut':
        return `Usuario: ${more_info.username}, salio del sistema`;
      case 'CreateCase':
      case 'EditCase':
      case 'DeleteCase':
        return `${more_info.gai}-${more_info.description}`;
      case 'CaseFinished':
      case 'CaseRequestApproval':
      case 'CaseDeleteFile':
      case 'CaseAddFile':
      case 'RequestAprovalCase':
      case 'AcceptApprovalCase':
      case 'RejectApprovalCase':
      case 'CaseRemitedFrom':
      case 'AddComentCase':
      case 'AddTaskCase':
      case 'DeleteTaskCase':
      case 'ChangeTaskCase':
      case 'AddFileTaskCase':
      case 'DeleteFileTaskCase':
        return `${more_info}`;
      case 'Create User':
        return `Usuario: ${more_info.username}, fue creado`;
      case 'Update User':
        return `${more_info}`;
      case 'Delete User':
        return `Username: ${more_info.username},fue eliminado`;
      case 'CreateUnit':
        return `Nombre: ${more_info.name}, fue creado`;
      case 'UpdateUnit':
        return ` ${more_info}`;
      case 'DeleteUnit':
        return `Nombre: ${more_info.name}, fue eliminado`;
      case 'CreateRole':
        return `El rol nombre: ${more_info.name} ,fue creado`;
      case 'UpdateRole':
        return ` ${more_info} `;
      case 'DeleteRole':
        return `El rol nombre: ${more_info.name} ,fue eliminado`;
      case 'CreateCaseType':
        return `El tipo de caso nombre: ${more_info.name} ,fue creado`;
      case 'UpdateCaseType':
        return `${more_info}`;
      case 'CreateTask':
        return `La tarea: ${more_info.title} ,fue creado`;
      case 'UpdateTask':
      case 'unlockUser':
      case 'triedLogin':
      case 'blockUser':
      case 'logOutTime':
      case 'TryDeleteRole':
      case 'RequestreportResume':
        return `${more_info}`;
      case 'DeleteTask':
        return `La tarea: ${more_info.title} ,fue eliminado`;

      default:
        return more_info;
    }
  }

  private getActionText(action: string): string {
    switch (action) {
      case 'CreateCase':
        return 'Creación de un caso';
      case 'EditCase':
        return 'Edición de un caso';
      case 'DeleteCase':
        return 'Eliminación de un caso';
      case 'Create User':
        return 'Creación de un Usuario';
      case 'Update User':
        return 'Actualización de un Usuario';
      case 'Delete User':
        return 'Eliminación de un Usuario';
      case 'Blocked User':
        return 'Bloqueo de un Usuario';
      case 'Update Password User':
        return 'Actualización de password de un Usuario';
      case 'CreateRole':
        return 'Creación de un Rol';
      case 'UpdateRole':
        return 'Actualización de un Rol';
      case 'DeleteRole':
        return 'Eliminación de un Rol';
      case 'CreateUnit':
        return 'Creación de una Unidad';
      case 'UpdateUnit':
        return 'Actualización de una Unidad';
      case 'DeleteUnit':
        return 'Eliminación de una Unidad';
      case 'CreateCaseType':
        return 'Creación de un Tipo de Caso';
      case 'UpdateCaseType':
        return 'Actualización de un Tipo de Caso';
      case 'DeleteCaseType':
        return 'Eliminación de un Tipo de Caso';
      case 'CreateTask':
        return 'Creación de una Tarea';
      case 'UpdateTask':
        return 'Actualización de una Tarea';
      case 'DeleteTask':
        return 'Eliminación de una Tarea';
      case 'Login':
        return 'Ingreso al sistema';
      case 'LogOut':
      case 'logOutTime':
        return 'Salio del sistema';
      case 'unlockUser':
        return 'Desbloqueo usuario';
      case 'triedLogin':
        return 'Intento de ingresar';
      case 'blockUser':
        return 'Usuario bloqueado';
      case 'TryDeleteRole':
        return 'Intento de eliminar rol';
      case 'RequestreportResume':
        return 'Consulta informe de productividad';
      case 'AssistantToolExecuted':
        return 'Asistente IA: acción ejecutada';
      case 'AssistantToolFailed':
        return 'Asistente IA: acción fallida';

      default:
        return action;
    }
  }

  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Logs_CSV',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'Logs_CSV',
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  };
  exportToCsv() {
    let copyData = this.auditoryLogs.map((data) => {
      data.user = data.user.username;
      delete data._id;
      return data;
    });

    const csvExporter = new ExportToCsv(this.options);

    csvExporter.generateCsv(copyData);
  }
}
